import script from "./Navigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./Navigation.vue?vue&type=script&setup=true&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=5b9b1661&lang=css"

const __exports__ = script;

export default __exports__